import { render } from "./BankBranches.vue?vue&type=template&id=2e45cd4c"
import script from "./BankBranches.vue?vue&type=script&lang=js"
export * from "./BankBranches.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__